import { TokenService } from 'src/app/services/token/token.service';
import { AuthFacade } from 'src/app/store/auth/facade/auth.facade';
import { FeatureToggleService } from './../feature-toggle/feature-toggle.service';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

@Injectable()
export class FeatureGuardService  {

    private userIsInvestorSubscription: Subscription;
    private isUserInvestor = false;
    constructor(private featureToggleService: FeatureToggleService, private authFacade: AuthFacade, private tokenService: TokenService) {
        this.setDataSubscriptions();
    }

    private setDataSubscriptions() {
        if (this.userIsInvestorSubscription) {
            this.userIsInvestorSubscription.unsubscribe();
        }
        this.userIsInvestorSubscription = this.authFacade.isUserInvestor$.subscribe((isUserInvestor: boolean) => {
            this.isUserInvestor = isUserInvestor;
        });
    }

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const feature = route.data['feature'];

        if (!feature) {
            return false;
        }
        return (this.isUserInvestor) ? this.featureToggleService.featureIndividualInvestorOn(feature) : this.featureToggleService.featureOn(feature);
    }
}
